import { render, staticRenderFns } from "./lender-note.vue?vue&type=template&id=5d60b5ea"
import script from "./lender-note.vue?vue&type=script&lang=js"
export * from "./lender-note.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports